<!-- Project Settings -->
<app-section-card title="Project Settings" [collapsed]="false">
  <div class="px-3 py-3 flex flex-col gap-3">
    <div class="form-row">
      <div class="form-field">
        <label class="form-label">Name</label>
        <input pInputText class="w-full" [ngModel]="data().name" (ngModelChange)="setName($event)" />
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label">FPS</label>
        <p-inputnumber [ngModel]="data().fps" (ngModelChange)="setFps($event)"
          [showButtons]="false" styleClass="p-inputnumber-fluid" />
      </div>
      <div class="form-field">
        <label class="form-label">Audio Sample Rate</label>
        <p-select [options]="audioSampleRateOptions" optionValue="value" appendTo="body"
          [ngModel]="data().audioSampleRate ?? 44100" (ngModelChange)="setAudioSampleRate($event)"
          styleClass="p-select-fluid" />
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="form-label">Orig W</label>
        <p-inputnumber [ngModel]="data().origCoordsWidth" (ngModelChange)="setOrigWidth($event)"
          [showButtons]="false" styleClass="p-inputnumber-fluid" />
      </div>
      <div class="form-field">
        <label class="form-label">Orig H</label>
        <p-inputnumber [ngModel]="data().origCoordsHeight" (ngModelChange)="setOrigHeight($event)"
          [showButtons]="false" styleClass="p-inputnumber-fluid" />
      </div>
    </div>

    <div class="form-row">
      <div class="form-field form-field--check">
        <p-checkbox inputId="hide-subtitles-check" [binary]="true" [ngModel]="data().hideSubtitlesButton ?? false"
          (ngModelChange)="setHideSubtitlesButton($event)" />
        <label class="form-label" for="hide-subtitles-check">Hide Subtitles Button</label>
      </div>
      <div class="form-field form-field--check">
        <p-checkbox inputId="clickable-thumbnail-check" [binary]="true" [ngModel]="data().clickableThumbnail ?? false"
          (ngModelChange)="setClickableThumbnail($event)" />
        <label class="form-label" for="clickable-thumbnail-check">Clickable Thumbnail (hide play button)</label>
      </div>
    </div>

  </div>
</app-section-card>

<app-dimensions-editor
  title="Dimensions Map"
  [dimensionsMap]="data().dimensionsMap ?? {}"
  (dimensionsMapChange)="patch(d => d.dimensionsMap = $event)"
/>


<!-- Chapters -->
<app-section-card title="Chapters" [badge]="(data().chapters ?? []).length">
  @if ((data().chapters ?? []).length === 0) {
    <div class="px-3 py-4 text-center text-wb-muted text-[12px]">No chapters defined.</div>
  } @else {
    <div cdkDropList (cdkDropListDropped)="dropChapter($event)" class="chapter-list">
      @for (chapter of data().chapters; track $index; let ci = $index) {
        <div cdkDrag class="item-row item-row--link" (click)="onChapterClick(chapter, $event)">
          <div *cdkDragPlaceholder class="chapter-drag-placeholder"></div>
          <span cdkDragHandle class="drag-handle" (click)="$event.stopPropagation()">
            <i class="pi pi-bars text-[9px]"></i>
          </span>
          <i class="pi pi-folder text-[10px] text-wb-accent shrink-0"></i>
          <span class="font-mono text-[12px] text-wb-text font-semibold truncate flex-1">{{ chapter.slug }}</span>
          @if ($any(chapter).groups?.length || $any(chapter).group) {
            <span class="text-[10px] text-wb-accent-2 shrink-0" title="Gated on attributes — the player skips this chapter when they do not match"><i class="pi pi-tag text-[9px]"></i></span>
          }
          <div class="flex items-center gap-2 text-[11px] shrink-0">
            @if (chapter.scenes.length) {
              <span class="text-wb-success"><i class="pi pi-play text-[9px]"></i> {{ chapter.scenes.length }}</span>
            }
            @if ((chapter.images ?? []).length) {
              <span class="text-wb-accent-2"><i class="pi pi-image text-[9px]"></i> {{ (chapter.images ?? []).length }}</span>
            }
            @if ((chapter.audioTrack ?? []).length) {
              <span class="text-wb-warn"><i class="pi pi-volume-up text-[9px]"></i> {{ (chapter.audioTrack ?? []).length }}</span>
            }
          </div>
          <button pButton [text]="true" size="small" severity="danger" class="wb-icon-btn"
            (click)="removeChapter(ci, $event)"><i class="pi pi-trash"></i></button>
          <i class="pi pi-arrow-right text-[9px] text-wb-muted shrink-0 go-arrow"></i>
        </div>
      }
    </div>
  }
  <div class="px-3 py-2">
    <button class="add-item-btn" type="button" (click)="addChapter()"><i class="pi pi-plus text-[9px]"></i> Add Chapter</button>
  </div>
</app-section-card>

<!-- Project-level Scenes -->
<app-section-card title="Scenes" [badge]="(data().scenes ?? []).length">
  @if ((data().scenes ?? []).length === 0) {
    <div class="px-3 py-4 text-center text-wb-muted text-[12px]">No project-level scenes.</div>
  } @else {
    <div cdkDropList (cdkDropListDropped)="dropScene($event)" class="chapter-list">
      @for (scene of data().scenes; track $index; let si = $index) {
        <div cdkDrag>
          <div class="item-row item-row--link" (click)="onSceneClick(scene, $event)">
            <div *cdkDragPlaceholder class="chapter-drag-placeholder"></div>
            <span cdkDragHandle class="drag-handle" (click)="$event.stopPropagation()">
              <i class="pi pi-bars text-[9px]"></i>
            </span>
            <i class="pi pi-play text-[10px] text-wb-success shrink-0"></i>
            <span class="font-mono text-[12px] text-wb-text font-semibold truncate flex-1">{{ scene.slug }}</span>
            @if ($any(scene).variant) {
              <span class="text-[10px] text-wb-accent shrink-0" title="Variant"><i class="pi pi-users text-[9px]"></i></span>
            }
            @if ($any(scene).groups?.length) {
              <span class="text-[10px] text-wb-accent-2 shrink-0" title="Has attributes"><i class="pi pi-tag text-[9px]"></i></span>
            }
            @if (scene.disabled) {
              <span class="text-[10px] text-wb-danger shrink-0">off</span>
            }
            @if ($any(scene).alt) {
              <span class="text-[10px] text-wb-muted shrink-0" title="Alternative (fallback) scene">alt</span>
            }
            <button pButton [text]="true" size="small" severity="secondary" class="wb-icon-btn"
              (click)="toggleSceneExpand(si, $event)" title="Edit attributes"><i [class]="expandedScene() === si ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i></button>
            <button pButton [text]="true" size="small" severity="secondary" class="wb-icon-btn"
              (click)="requestCopyScene(si, $event)" title="Copy scene"><i class="pi pi-copy"></i></button>
            <button pButton [text]="true" size="small" severity="danger" class="wb-icon-btn"
              (click)="removeScene(si, $event)"><i class="pi pi-trash"></i></button>
            <i class="pi pi-arrow-right text-[9px] text-wb-muted shrink-0 go-arrow"></i>
          </div>
          @if (expandedScene() === si) {
            <div class="px-3 py-2 bg-wb-bg flex flex-col gap-2">
              <div class="flex items-center gap-1.5">
                <p-checkbox [inputId]="'scene-alt-check-' + si" [binary]="true" [ngModel]="$any(scene).alt ?? false" (ngModelChange)="setSceneAlt(si, $event)" />
                <label class="form-label" [attr.for]="'scene-alt-check-' + si">Alternative scene</label>
              </div>
              <div>
                <label class="form-label">Attributes</label>
                <app-attributes-editor
                  [data]="$any(scene).attributes ?? null"
                  (dataChange)="setSceneAttributes(si, $event)"
                />
              </div>
              @if ($any(scene).variant) {
                <app-variant-editor
                  [data]="$any(scene).variant"
                  mode="scene"
                  [argKeys]="getArgKeys()"
                  [siblingSlug]="getSceneSlugs()"
                  (dataChange)="setSceneVariant(si, $event)"
                  (namesMapPopulate)="onNamesMapPopulate($event)"
                />
              }
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="px-3 py-2 flex gap-2">
    <button class="add-item-btn" type="button" (click)="openSceneVideoPicker()"><i class="pi pi-video text-[9px]"></i> Add Scenes from Videos</button>
    <button class="add-item-btn" type="button" (click)="openSceneImagePicker()"><i class="pi pi-image text-[9px]"></i> Add Scenes from Images</button>
  </div>
</app-section-card>

<app-media-picker
  [(visible)]="sceneVideoPickerVisible"
  [categories]="sceneVideoPickerCategories"
  [multi]="true"
  currentValue=""
  (filesSelected)="onSceneVideosSelected($event)"
/>

<app-media-picker
  [(visible)]="sceneImagePickerVisible"
  [categories]="sceneImagePickerCategories"
  [multi]="true"
  currentValue=""
  (filesSelected)="onSceneImagesSelected($event)"
/>

<!-- Project-level Images -->
<app-section-card title="Images" [badge]="(data().images ?? []).length">
  @if ((data().images ?? []).length === 0) {
    <div class="px-3 py-4 text-center text-wb-muted text-[12px]">No project-level images.</div>
  } @else {
    <div cdkDropList (cdkDropListDropped)="dropImage($event)" class="chapter-list">
      @for (img of data().images; track $index; let ii = $index) {
        <div cdkDrag>
          <div class="item-row item-row--link" (click)="onImageClick(img, $event)">
            <div *cdkDragPlaceholder class="chapter-drag-placeholder"></div>
            <span cdkDragHandle class="drag-handle" (click)="$event.stopPropagation()">
              <i class="pi pi-bars text-[9px]"></i>
            </span>
            <i class="pi pi-image text-[10px] text-wb-accent-2 shrink-0"></i>
            <span class="font-mono text-[12px] text-wb-text font-semibold truncate flex-1">{{ img.slug }}</span>
            @if ($any(img).groups?.length) {
              <span class="text-[10px] text-wb-accent-2 shrink-0" title="Has attributes"><i class="pi pi-tag text-[9px]"></i></span>
            }
            @if (img.thumbnail) {
              <span class="text-[10px] text-wb-warn shrink-0">thumb</span>
            }
            @if (img.disabled) {
              <span class="text-[10px] text-wb-danger shrink-0">off</span>
            }
            <button pButton [text]="true" size="small" severity="secondary" class="wb-icon-btn"
              (click)="toggleImageExpand(ii, $event)" title="Edit attributes"><i [class]="expandedImage() === ii ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i></button>
            <button pButton [text]="true" size="small" severity="secondary" class="wb-icon-btn"
              (click)="requestCopyImage(ii, $event)" title="Copy image"><i class="pi pi-copy"></i></button>
            <button pButton [text]="true" size="small" severity="danger" class="wb-icon-btn"
              (click)="removeImage(ii, $event)"><i class="pi pi-trash"></i></button>
            <i class="pi pi-arrow-right text-[9px] text-wb-muted shrink-0 go-arrow"></i>
          </div>
          @if (expandedImage() === ii) {
            <div class="px-3 py-2 bg-wb-bg">
              <label class="form-label">Attributes</label>
              <app-attributes-editor
                [data]="$any(img).attributes ?? null"
                (dataChange)="setImageAttributes(ii, $event)"
              />
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="px-3 py-2">
    <button class="add-item-btn" type="button" (click)="openImagePicker()"><i class="pi pi-image text-[9px]"></i> Add Images from Files</button>
  </div>
</app-section-card>

<app-media-picker
  [(visible)]="imagePickerVisible"
  [categories]="imagePickerCategories"
  [multi]="true"
  currentValue=""
  (filesSelected)="onImagesSelected($event)"
/>

<!-- Project-level Audio Tracks -->
<app-audio-track-editor
  [audioTrack]="data().audioTrack ?? []"
  [argKeys]="getArgKeys()"
  [sceneSlugs]="sceneSlugs()"
  (audioTrackChange)="onAudioTrackChange($event)"
  (namesMapPopulate)="onNamesMapPopulate($event)"
/>

<!-- Subtitles -->
<app-subtitle-track-editor
  [subtitles]="data().subtitles ?? []"
  [subtitleSources]="data().__platformContent?.subtitleSources ?? {}"
  [chapters]="data().chapters ?? []"
  (subtitlesChange)="onSubtitlesChange($event)"
  (subtitleSourcesChange)="onSubtitleSourcesChange($event)"
/>
